import React, { Component } from 'react';
import {
	ApLoaderDefault,
	ApLoaderText,
	ApButtonGroup,
	ApButtonMain,
	ApButtonSecondary,
} from '@alixpartners/ui-components';
import { saveClassificationSettings } from 'utils/apiRequests';
import { ClassificationColumns } from '../components/ConfigureClassificationStep';
import { HarmonisationOptions } from '../components/ConfigureHarmonisationStep';
import {
	Container,
	Section,
	SectionContent,
	SectionLabel,
	SubTitle,
	Title,
	LoadingContainer,
	Description,
	Text,
	SaveButton,
	Wrapper,
	StyledModal,
	ModalBody,
	ModalHeader,
	Subheader,
	Divider,
	InnerContainer,
} from './styles';
import isEqual from 'lodash/isEqual';
import { withRouter } from 'react-router';

export class ConfigureDpaas extends Component {
	state = {
		config: this.props.config,
		isConfirmationOpen: false,
		isSaving: false,
	};

	componentDidUpdate(prevProps) {
		const { config } = this.props;

		if (!isEqual(config, prevProps.config)) {
			this.setState({ config });
		}
	}

	saveConfig = () => {
		const { config } = this.state;
		const configWithoutLabels = {
			...config,
			columns: config.columns.map(column => {
				const { labels, ...withoutLabels } = column;

				return withoutLabels;
			}),
		};

		this.setState({ isSaving: true });

		saveClassificationSettings(configWithoutLabels).then(() => {
			this.setState({ isSaving: false });
			this.showConfirmation();
		});
	};

	showConfirmation = () => {
		this.setState({ isConfirmationOpen: true });
	};

	hideConfirmation = () => {
		this.setState({ isConfirmationOpen: false });
	};

	onColumnsChange = e => {
		const { config } = this.state;
		const { name: clickedColumnName, checked: isSelected } = e.target;
		const updatedColumns = config.columns.map(item => {
			if (item.name === clickedColumnName) {
				return { ...item, isSelected };
			}

			return item;
		});

		this.setState({ config: { ...config, columns: updatedColumns } });
	};

	onOptionChange = e => {
		const { config } = this.state;
		const { value: key, checked } = e.target;
		const { columns, ...options } = config;

		if (!checked) {
			delete options[key];
		} else {
			options[key] = true;
		}

		this.setState({
			config: { columns, ...options },
		});
	};

	onConfirm = () => {
		const { fetchClassification } = this.props;

		fetchClassification();
		this.hideConfirmation();
	};

	render() {
		const { config, isConfirmationOpen, isSaving } = this.state;
		const { history } = this.props;

		if (!config) {
			return (
				<LoadingContainer>
					<ApLoaderDefault loaderText={() => <ApLoaderText />} />
				</LoadingContainer>
			);
		}

		return (
			<Wrapper>
				<Subheader>
					{history.action !== 'POP' && (
						<React.Fragment>
							<ApButtonSecondary
								iconName="baseline_arrow_back"
								onClick={() => history.goBack()}
							>
								Back
							</ApButtonSecondary>
							<Divider />
						</React.Fragment>
					)}

					<Title>DPaaS Configuration</Title>
					<Text>
						Save the configuration ready for the first DPaaS ingestion
					</Text>
					<SaveButton disabled={isSaving} onClick={this.saveConfig}>
						Save
					</SaveButton>
				</Subheader>
				<Container>
					<InnerContainer>
						<Section>
							<SectionLabel>
								<SubTitle>
									Please select options to influence the harmonization of the
									Vendor name
								</SubTitle>
							</SectionLabel>
							<SectionContent>
								<HarmonisationOptions
									onChange={this.onOptionChange}
									data={config}
								/>
							</SectionContent>
						</Section>
						<Section>
							<SectionLabel>
								<SubTitle>Select classification data fields</SubTitle>
								<Description>
									Select columns that can be used to help classify the data.
									Note - if you select columns that contain poor or irrelevant
									data, the results of the classification are likely to be
									skewed.
								</Description>
							</SectionLabel>
							<SectionContent>
								<ClassificationColumns
									onChange={this.onColumnsChange}
									data={config.columns}
								/>
							</SectionContent>
						</Section>
					</InnerContainer>
				</Container>
				{isConfirmationOpen && (
					<StyledModal
						isOpen={isConfirmationOpen}
						hasClosed={this.hideConfirmation}
						header={<ModalHeader>DPaaS configuration saved</ModalHeader>}
						footer={() => {
							return (
								<ApButtonGroup justifyContent="flex-end">
									<ApButtonMain onClick={this.onConfirm}>Ok</ApButtonMain>
								</ApButtonGroup>
							);
						}}
					>
						<ModalBody>
							You have successfully configured the application for DPaaS
						</ModalBody>
					</StyledModal>
				)}
			</Wrapper>
		);
	}
}

export default withRouter(ConfigureDpaas);
